// extracted by mini-css-extract-plugin
export default {"label":"label__AsK3F","input":"input__qh7sD","icon":"icon__+8KKx","icon--checked":"icon--checked__EMkIi","icon--unchecked":"icon--unchecked__6Vk0u"};